import { BACKEND_LOYAL, BACKEND_PRIVATE, BACKEND_PUBLIC } from '../base'

export async function getCategoryRoles() {
  return BACKEND_PUBLIC.get('/primary-role-categories/list')
}

export async function createVacancy(payload: any) {
  return BACKEND_PRIVATE.post('/me/vacancy/create', { payload })
}

export async function updateVacancy(id: number, payload: any) {
  return BACKEND_PRIVATE.put('/me/vacancy/edit', { id, payload })
}

export async function publishVacancy(id: number) {
  return BACKEND_PRIVATE.post('/me/vacancy/publish', { id })
}

export async function unpublishVacancy(id: number) {
  return BACKEND_PRIVATE.post('/me/vacancy/unpublish', { id })
}

export async function deleteVacancy(id: number) {
  return BACKEND_PRIVATE.delete('/me/vacancy/remove', { data: { id } })
}

export async function getVacancy(id: number | string) {
  return BACKEND_LOYAL.get('/vacancy/get', { params: { id } })
}

export async function getMyPostedVacancies(limit = 10, offset = 0) {
  return BACKEND_PRIVATE.get('/me/vacancy/list-posted', { params: { limit, offset } })
}

export async function getMyDraftsVacancies(limit = 10, offset = 0) {
  return BACKEND_PRIVATE.get('/me/vacancy/list-drafted', { params: { limit, offset } })
}

export async function getMyCompletedVacancies(limit = 10, offset = 0) {
  return BACKEND_PRIVATE.get('/me/vacancy/list-completed', { params: { limit, offset } })
}

export async function getMyFreelancerApplications(params: any) {
  return BACKEND_PRIVATE.get('/me/vacancy/applications/list-as-freelancer', { params })
}

export async function getVacancies(params: any) {
  return BACKEND_LOYAL.get('/vacancy/list', { params })
}

export async function getCvs() {
  return BACKEND_PRIVATE.get('/me/freelancer/cv-list')
}

export async function archiveVacancy(id: number) {
  return BACKEND_PRIVATE.post('/me/vacancy/archive', { id })
}

export async function unArchiveVacancy(id: number) {
  return BACKEND_PRIVATE.post('/me/vacancy/unarchive', { id })
}

export async function vacancyUnArchive(id: number, token: string) {
  return BACKEND_PUBLIC.post('/vacancy/unarchive', { id, token })
}
